
              const Handlebars = require('handlebars');
              const templateFunction = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  return "";
},"useData":true});
              Handlebars.templates['src/hbs/partials/mobile_logo_bar.hbs'] = templateFunction;
              export default templateFunction;
              